import { errorHelpers } from '@approvalmax/utils';
import padStart from 'lodash/padStart';
import { ui } from 'modules/common';
import { domain } from 'modules/data';

import { MappedBudget } from '../../../../hooks/useBudgets';
import { messages } from './BudgetParams.messages';

export const getCheckPeriodText = (budget: MappedBudget) => {
    const { checkPeriod, checkPeriodFirstMonth, checkPeriodFrom, checkPeriodTill } = budget;

    const month = ui.allMonthReferences.find((r) => r.monthIndex === checkPeriodFirstMonth);

    if (!checkPeriod) return '';

    switch (checkPeriod) {
        case domain.BudgetCheckPeriod.Monthly:
            return messages.checkPeriodMonthly;

        case domain.BudgetCheckPeriod.Quarterly:
            return messages.checkPeriodQuarterly;

        case domain.BudgetCheckPeriod.Semiannually:
            return messages.checkPeriodHalfYearly;

        case domain.BudgetCheckPeriod.Annually:
            return messages.checkPeriodYearly;

        case domain.BudgetCheckPeriod.YearToDate:
            return messages.checkPeriodYTD;

        case domain.BudgetCheckPeriod.AnnuallyWithCustomFirstMonth:
            return messages.annuallyWithCustomFirstMonth({ month: month?.text });

        case domain.BudgetCheckPeriod.YearToDateWithCustomFirstMonth:
            return messages.yearToDateWithCustomFirstMonth({ month: month?.text });

        case domain.BudgetCheckPeriod.Custom: {
            const startMonth = checkPeriodFrom
                ? `${checkPeriodFrom.year}-${padStart(String(checkPeriodFrom.month), 2, '0')}`
                : null;

            const endMonth = checkPeriodTill
                ? `${checkPeriodTill.year}-${padStart(String(checkPeriodTill.month), 2, '0')}`
                : null;

            return messages.customMonthPeriod({
                from: startMonth || '',
                to: endMonth || '',
            });
        }

        default:
            throw errorHelpers.assertNever(checkPeriod);
    }
};
